import React, { useState } from 'react';
import './FaqSection.scss';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqComponentProps {
  title: string;
  subtitle?: string;
  items: FaqItem[];
}

const FaqComponent: React.FC<FaqComponentProps> = ({
  title,
  subtitle,
  items
}) => {
  const [openItemIndex, setOpenItemIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenItemIndex(openItemIndex === index ? null : index);
  };

  return (
    <section className="faq-component">
      <div className="faqContainer">
        <div className="faq-header">
          <h2 className="faq-title">{title}</h2>
          {subtitle && <p className="faq-subtitle">{subtitle}</p>}
        </div>

        <div className="faq-content">
          <div className="faq-list">
            {items.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item ${openItemIndex === index ? 'open' : ''}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleItem(index)}
                  aria-expanded={openItemIndex === index}
                >
                  {item.question}
                  <span className="faq-icon">
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </button>
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqComponent;